import { Link } from 'react-router-dom';

export default function ArticleCTASection() {
  return (
    <section className="py-16 md:py-24 relative overflow-hidden">
      <div
        className="absolute inset-0 bg-cover bg-center bg-no-repeat"
        style={{
          backgroundImage: `url('https://readdy.ai/api/search-image?query=Warm%20inviting%20reading%20nook%20flatlay%20on%20soft%20cream%20surface%2C%20an%20open%20notebook%20with%20handwritten%20notes%20beside%20a%20steaming%20ceramic%20coffee%20cup%20and%20reading%20glasses%2C%20soft%20golden%20hour%20window%20light%20casting%20gentle%20shadows%2C%20editorial%20lifestyle%20photography%2C%20cozy%20intellectual%20aesthetic%2C%20warm%20amber%20and%20sand%20tones%2C%20clean%20sophisticated%20composition&width=1600&height=600&seq=cta-reading-kakobuy-02&orientation=landscape')`,
        }}
      />
      <div className="absolute inset-0 bg-black/30"></div>

      <div className="relative max-w-7xl mx-auto px-4 md:px-6 text-center">
        <div className="max-w-xl mx-auto">
          <span className="inline-block text-xs font-semibold tracking-widest uppercase text-accent-300 mb-4">
            Dowiedz się więcej
          </span>
          <h2 className="text-2xl md:text-4xl font-heading font-bold text-background-50 mb-4">
            Chcesz dowiedzieć się więcej?
          </h2>
          <p className="text-sm md:text-base text-background-50/75 leading-relaxed mb-8">
            Przeczytaj nasz kompletny przewodnik Kakobuy Spreadsheet – wszystko co musisz wiedzieć o zakupach, bezpieczeństwie i najlepszych produktach w jednym miejscu.
          </p>
          <Link
            to="/artykul/kakobuy-spreadsheet"
            className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-background-50 px-7 py-3.5 rounded-full text-sm font-semibold transition-all hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Przeczytaj pełny artykuł
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}